module.exports = __webpack_public_path__ + "static/interior_on_left-67dd370494d5b2b02030c88c8b03fa72.png";